import { isEmpty, map } from 'lodash';

import { LccnPermalinksSet } from '@app/components';

import { DownloadFormat } from '../../constants';

const supportedLinks = {
  marcxml: 'MARC XML',
  mods: 'MODS',
  bibframe2: 'Bibframe',
  dc: 'Dublin Core',
};

export const getMarcDownloadFormats = (
  permalinksSets?: LccnPermalinksSet[]
): DownloadFormat[] => {
  const firstPermalinkSet = permalinksSets?.[0];

  if (isEmpty(firstPermalinkSet)) {
    return [];
  }

  return map(supportedLinks, (key, value) => ({
    name: key,
    link: firstPermalinkSet[value],
  })).filter(({ link }) => Boolean(link));
};
